<template>
	<AppLayout :title="trans('college_zones.representatives.create.title')">
		<template #actions>
			<PrimaryButton :color="Color.Green" @click.stop="create">
				<i class="fa-solid fa-plus mr-2"/>
				{{ trans('general.create') }}
			</PrimaryButton>
		</template>
		<Card :title="trans('general.terms.title')">
			<ol class="pl-6 list-decimal list-outside leading-loose">
				<li v-for="term in trans('college_zones.representatives.create.terms')">{{ term }}</li>
			</ol>
			<template #footer>
				<Switch v-model="acceptance" :label="trans('general.terms.accept')"/>
			</template>
		</Card>
	</AppLayout>
</template>
<script setup lang="ts">
import 'dayjs/locale/es'
import axios from 'axios'
import dayjs from 'dayjs'
import {route} from 'ziggy-js'
import {ref, type Ref} from 'vue'
import {router} from '@inertiajs/vue3'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import Card from '@/Components/Cards/Card.vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import Switch from '@/Components/Switch/Switch.vue'
import PrimaryButton from '@/Components/Buttons/PrimaryButton.vue'
import {type EventPeriod} from '@/Types/Periods/Events/EventPeriod'
import {showInfo, showSuccess, showValidationErrors} from '@/helpers'

const props = defineProps<{
	locale:string,
	hasPendingRequests:boolean,
	periods:Array<EventPeriod>,
}>()

dayjs.locale(props.locale)
const working:Ref<boolean> = ref(false)
const acceptance:Ref<boolean> = ref(false)

function create():void{
	if(!working.value){
		working.value = true
		showInfo(trans('general.inserting'))
		axios.post(route('college-zones.representatives.store'), {
			acceptance: acceptance.value,
		}).then(() => {
			showSuccess(trans('general.inserted'))
			router.get(route('college-zones.representatives.index'))
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}
</script>